import { apiVersion, wsUrl } from "../../config";
import localforage from "localforage";
import { Subject, } from "rxjs"

export async function subscribeToTaskChanges () {
    const subject = new Subject();

    const token = await localforage.getItem("339vending.admin-token");
    let stream = new WebSocket(`${ wsUrl }/${ apiVersion }/task?token=${ token }`);

    stream.onmessage = (evt) => {
        if (evt.data) {
            subject.next(JSON.parse(evt.data));
        }
    }

    stream.onclose = (evt) => {
        stream = new WebSocket(`${ wsUrl }/${ apiVersion }/task?token=${ token }`);
    }

    stream.onerror = (err) => {
        console.error(err);
        console.error("subscribeToMessage stream errored");
        stream = new WebSocket(`${ wsUrl }/${ apiVersion }/task?token=${ token }`);
    }

    return subject;
}

export default subscribeToTaskChanges;
